import React from 'react';
import { BrowserRouter as Router, Route, Routes } from 'react-router-dom';
import IndexPage from './components/pages/IndexPage';
import ProductDetailPage from './components/pages/ProductDetailPage';
import ProductListingPage from './components/pages/ProductListingPage';
import UnifiedCartPage from './components/pages/UnifiedCartPage';
import CheckoutPage from './components/pages/CheckoutPage';
import ProtectedRoute from './components/ProtectedRoute';
import NotFoundPage from './components/pages/NotFoundPage';
import AuthPage from './components/pages/AuthPage';
import AccountPage from './components/pages/Account/AccountPage';
import OrderConfirmationPage from './components/pages/OrderConfirmationPage';
import PaymentCompletePage from './components/pages/PaymentCompletePage';
import ForgotPasswordPage from './components/pages/ForgotPasswordPage.js';
import ResetPasswordPage from './components/pages/ResetPasswordPage.js';
import ContactPage from './components/pages/ContactPage.js';
import DynamicPage from './components/pages/DynamicPage.js';
import OrderCancelledPage from './components/pages/OrderCancelledPage.js';
import RelayPoints from './components/pages/RelayPoints.js';
import PreOrderPage from './components/pages/PreOrderPage.js';
import WorkshopPage from './components/pages/WorkshopPage.js';
import WorkshopListingPage from './components/pages/WorkshopListingPage.js';
import WorkshopDetailPage from './components/pages/WorkshopDetailPage.js';
import WorkshopConfirmationPage from './components/pages/WorkshopConfirmationPage.js';
import WorkshopPaymentCompletePage from './components/pages/WorkshopPaymentCompletePage.js';
import LoisirListingPage from './components/pages/LoisirListingPage';
import LoisirSelectionPage from './components/pages/LoisirSelectionPage';
import LoisirCheckoutPage from './components/pages/LoisirCheckoutPage';
import LoisirPaymentCompletePage from './components/pages/LoisirPaymentCompletePage';
import LoisirConfirmationPage from './components/pages/LoisirConfirmationPage';

import ProductSaleListingPage from './components/pages/ProductSaleListingPage';
import ProductSaleDetailPage from './components/pages/ProductSaleDetailPage';
import SaleCartPage from './components/pages/SaleCartPage';
import SaleCheckoutPage from './components/pages/SaleCheckoutPage';
import SalePaymentCompletePage from './components/pages/SalePaymentCompletePage';
import SaleConfirmationPage from './components/pages/SaleConfirmationPage';
import MetaPixelTracker from './MetaPixelTracker.js';

function App() {
  return (
    <Router>
      <MetaPixelTracker />
      <Routes>
        <Route path="/" element={<IndexPage />} />
        
        {/* Workshop routes */}
        <Route path="/nos-ateliers" element={<WorkshopPage />} />
        <Route path="/ateliers" element={<WorkshopListingPage />} />
        <Route path="/atelier/:id" element={<WorkshopDetailPage />} />
        <Route path="/atelier-confirmation" element={<WorkshopConfirmationPage />} />
        <Route path="/atelier-payment-complete" element={<WorkshopPaymentCompletePage />} />
        
        {/* Rental routes */}
        <Route path="/produit/:id" element={<ProductDetailPage />} />
        <Route path="/services/location" element={<ProductListingPage />} />
        <Route path="/panier" element={<UnifiedCartPage />} />
        <Route path="/checkout" element={<CheckoutPage />} />
        <Route path="/order-confirmation" element={<OrderConfirmationPage />} />
        <Route path="/payment-complete" element={<PaymentCompletePage />} />
        <Route path="/order-cancelled" element={<OrderCancelledPage />} />
        <Route path="/pre-order/:id" element={<PreOrderPage />} />
        
        {/* Loisir subscription routes */}
        <Route path="/loisirs" element={<LoisirListingPage />} />
        <Route path="/loisirs/selection" element={<LoisirSelectionPage />} />
        <Route path="/loisirs/checkout" element={<LoisirCheckoutPage />} />
        <Route path="/loisirs/payment-complete" element={<LoisirPaymentCompletePage />} />
        <Route path="/loisirs/confirmation" element={<LoisirConfirmationPage />} />

        {/* NEW: Sale routes */}
        <Route path="/vente" element={<ProductSaleListingPage />} />
        <Route path="/vente/produit/:id" element={<ProductSaleDetailPage />} />
        <Route path="/vente/panier" element={<UnifiedCartPage />} />
        <Route path="/vente/checkout" element={<SaleCheckoutPage />} />
        <Route path="/vente/payment-complete" element={<SalePaymentCompletePage />} />
        <Route path="/vente/confirmation" element={<SaleConfirmationPage />} />
        
        {/* Auth routes */}
        <Route path="/connexion" element={<AuthPage />} />
        <Route path="/forgot-password" element={<ForgotPasswordPage />} />
        <Route path="/reset-password" element={<ResetPasswordPage />} />
        
        {/* Other pages */}
        <Route path="/contact" element={<ContactPage />} />
        <Route path="/points-relais" element={<RelayPoints />} />
        <Route path="/page/:pageSlug" element={<DynamicPage />} />

        {/* Protected routes */}
        <Route
          path="/mon-compte"
          element={
            <ProtectedRoute>
              <AccountPage />
            </ProtectedRoute>
          }
        />

        {/* Catch all route for 404 */}
        <Route path="*" element={<NotFoundPage />} />

      </Routes>
    </Router>
  );
}

export default App;